import { z } from 'zod/v4';

/**
 * This function will return a successfully parsed object based on a zod schema or return an empty object and log a zod error to the console.
 * @param requestSchema zod schema
 * @param value value to parse
 * @returns Stringified JSON object of parsed schema
 */
export function parseRequestSchema<T extends z.ZodTypeAny>(
  requestSchema: T,
  value: unknown
) {
  try {
    const parsedValue = JSON.stringify(requestSchema.parse(value) as T);
    return parsedValue;
  } catch (zodError) {
    console.error(zodError);
  }
  return JSON.stringify({});
}
